import React from 'react'
import Logo from "../Assets/logo_icono.png"
import { BsTwitter } from 'react-icons/bs'
import {SiLinkedin} from "react-icons/si"
import { BsYoutube } from 'react-icons/bs'
import { FaFacebookF } from "react-icons/fa"
import { Instagram } from '@mui/icons-material'


const Footer = () => {
  return (
    <div className='footer-wrapper'>
        <div className='footer-section-one'>
            <div className='footer-logo-container'>
                <img src={Logo} alt=""   />
            </div>
            <div className='footer-icons'>
                
               <a href="https://www.instagram.com/the_lavc/reels/" target='_blank'><Instagram/></a>
                <a href="https://www.youtube.com/@latinamericanveterinarycon8403" target='_blank'><BsYoutube /></a>
                <a href="https://www.facebook.com/conferencia.veterinaria.latinoamericana" target='_blank'><FaFacebookF /></a>
                
            </div>            
        </div>
        <div className='footer-section-two'>
            <div className='footer-section-columns'>
                <span><a href="home">Home</a></span>
                <span><a href="programa">Programa</a></span>
                <span><a href="ubicacion">Ubicación</a></span>
                
                
            </div>
            <div className='footer-section-columns'>
                <span>Contacto</span>
                <span>informes@ellatin.com</span>
                
               
            </div>
                
            </div>
    </div>
  )
}

export default Footer